<template>
	<o-select
		v-if="setup.dataLoaded"
		v-model="setup.selectedRolesIds"
		:label="$t('common.shared.components.roleSelect.role')"
		display-key="name"
		track-key="id"
		value-key="id"
		:searchable="setup.options.length > 10"
		:options="setup.options"
		v-bind="{ ...$attrs, multiple }">
		<template #value="{ item: role }: { item: OrganizationRoleListItemEntity }">
			<template v-if="!multiple">
				<div
					v-if="role"
					class="role-option">
					<div
						class="role-color"
						:class="`background--${role.colorName}`"/>
					{{ role.name }}
				</div>
			</template>
			<template v-else>
				<div
					v-if="role && typeof role === 'number'"
					class="role-option">
					<div
						class="role-color"
						:class="`background--${setup.getRoleById(role)?.colorName}`"/>
					{{ setup.getRoleById(role)?.name }}
				</div>
				<div
					v-else-if="role"
					class="role-option">
					<div
						class="role-color"
						:class="`background--${role.colorName}`"/>
					{{ role.name }}
				</div>
			</template>
		</template>

		<template #option="{ item: role }: { item: OrganizationRoleListItemEntity }">
			<div class="role-option">
				<div
					class="role-color"
					:class="`background--${role.colorName}`"/>
				{{ role.name }}
			</div>
		</template>
	</o-select>
</template>

<script setup lang="ts">
// #region Setup
import type OrganizationRoleListItemEntity from '@/entity/OrganizationRoleListItemEntity';
import type { SharedRoleSelectEmits, SharedRoleSelectProps } from './SharedRoleSelectSetup';
import SharedRoleSelectSetup from './SharedRoleSelectSetup';
const emits = defineEmits<SharedRoleSelectEmits>() as SharedRoleSelectEmits;
const props = withDefaults(defineProps<SharedRoleSelectProps>(), SharedRoleSelectSetup.defaultProps);
const setup = new SharedRoleSelectSetup(props, emits);
// #endregion
</script>

<style scoped lang="less">
.role-color {
	width: 1rem;
	height: 1rem;
	border-radius: 0.25rem;

	.orion-select__selected-item & {
		width: 0.75rem;
	}
}

.role-option {
	cursor: pointer;
	display: flex;
	gap: 0.5rem;
	align-items: center;

	.orion-select__selected-item & {
		margin-right: 0.25rem;
	}
}
</style>
